import { TThunkAction } from '../../../types/redux';
import { getAuthorArticlesLoading } from './getAuthorArticlesLoading';
import { getAuthorArticlesSucceed } from './getAuthorArticlesSucceed';
import { getAuthorArticlesAppendSucceed } from './getAuthorArticlesAppendSucceed';
import { getAuthorArticlesFailed } from './getAuthorArticlesFailed';
import {
  fetchGetArticlesAuthor,
  IGetArticlesAuthorRequest,
  TGetArticlesAuthorResponse,
} from '../../../repositories/journal/v1/get-articles-author';
import { throwError } from '../../../utils';

export interface IGetAuthorArticlesParams {
  authorName: string;
  ordering?: IGetArticlesAuthorRequest['ordering'];
  offset?: number;
  limit?: number;
  setType?: 'set' | 'append';
}

export const getAuthorArticles = ({
  authorName,
  ordering,
  offset,
  limit,
  setType = 'set',
}: IGetAuthorArticlesParams): TThunkAction<Promise<void>> => {
  return async (dispatch, getState, context) => {
    const { httpApi, logger } = context;
    const {
      userNew: { isB2BModeEnabled },
    } = getState();

    dispatch(getAuthorArticlesLoading());

    try {
      const { response, statusCode }: TGetArticlesAuthorResponse = await fetchGetArticlesAuthor({
        httpApi,
        parameters: {
          b2b: isB2BModeEnabled,
          authorName,
          ordering,
          offset,
          limit,
        },
      });

      if (statusCode !== 200) {
        throwError({ message: 'Не удалось загрузить статьи автора', statusCode, domain: 'actions.getAuthorArticles' });

        return;
      }

      if (setType === 'append') {
        dispatch(getAuthorArticlesAppendSucceed({ meta: response.meta, items: response?.data || [] }));
      } else {
        dispatch(getAuthorArticlesSucceed({ meta: response.meta, items: response?.data || [] }));
      }
    } catch (e) {
      logger.error(e, {
        domain: 'actions.getAuthorArticles',
      });

      dispatch(getAuthorArticlesFailed());
    }
  };
};
